import { createStorage } from 'persistme'

var appLocalStorage = createStorage ('aris.'+process.env.VUE_APP_ID);

export default appLocalStorage;
